import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// styles
import {  Container , Row , Col  , ProgressBar} from 'react-bootstrap';
import { Paper } from '@material-ui/core';

export default function CompanyProfileStrength(props) {
    return(
        <Container fluid className="profileStrength mt-5 mb-3 p-0">
            <Paper>
                <Row className="m-0 p-3">
                    <Col xs={12} className="p-0 mb-2">
                        <h6 className="bold">Improve Your Profile</h6>
                        <p className="mb-0">Your profile strength is <span className="text-orange">83%</span></p>
                        </Col>
                    <Col xs={12} className="p-0 mb-2">
                        <ProgressBar  now='83' />
                    </Col>
                </Row>
            </Paper>
        </Container>
    )
}